/** URL helpers shared by the iframe entry route. */

import { parseExpectedParentOrigin } from './postMessage';

/** Historical campaign identity mode, retained for persisted navigation data. */
export type EmbedCollectInfo = 'pre' | 'post' | 'never';

/** Embed-mode params parsed from the iframe URL. */
export interface EmbedParams {
  embedOrigin: string;
  theme?: 'light' | 'dark';
}

/**
 * Read embed_origin from URL params. Returns null when the request is
 * not an embed (no embed_origin) or when embed_origin fails origin
 * validation.
 */
export function parseEmbedUrlParams(params: URLSearchParams): EmbedParams | null {
  const rawOrigin = params.get('embed_origin');
  if (!rawOrigin) return null;

  const origin = parseExpectedParentOrigin(rawOrigin);
  if (!origin) return null;

  const theme = params.get('embed_theme');
  return { embedOrigin: origin, ...(theme === 'light' || theme === 'dark' ? { theme } : {}) };
}
